// @ts-ignore: declaration file for './aic/components/AicUi/App' is missing
import Aic from './aic/components/AicUi/App';
const aicForm = document.querySelector('[data-mp-role="aic-form"]');

if (aicForm !== null) {
  const formEl = aicForm as HTMLElement;

  // data 属性から取得（なければ <html lang=""> を fallback に）
  let locale =
    formEl.dataset.aicUiAppLang || document.documentElement.lang || 'ja';

  // 必要なら正規化（例: 'en-US' → 'en' など）
  locale = locale.toLowerCase();
  if (locale.startsWith('en')) locale = 'en';
  if (locale.startsWith('zh')) locale = 'zh-hant'; // サイトの定義に合わせる
  if (locale.startsWith('th')) locale = 'th';

  new Aic({
    locale,
    aicAPIBaseURI: 'https://jc-cmn-api-03.machi-pla.com/api_v1/best_plans.json',
    apiKey: 'yplMsWA9g3pBusYnJcD',
    place: 'tazawako',
    wpAPIBaseURI: (aicForm as HTMLElement).dataset.wpSpotApiForAicBasePath,
    wpApiKey: 'yplMsWA9g3pBusYnJcD',
  });
}
